module.exports = __webpack_public_path__ + "img/cms_logo.2d603ffe.png";